import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { type QBankStructureLevel } from '@exam-management/qbs-provider';

export function getShallowestEnabledNonCourseLevel(
  qBankStructureLevels: QBankStructureLevel[],
): QBankStructureLevel | null {
  return (
    qBankStructureLevels
      .filter((level) => level.enabled && level.category !== QBankStructureLevelCategory.Course)
      .sort((a, b) => a.level - b.level)[0] ?? null
  );
}
